interface ReferenceContractData {
  jobTitle?: string | null
  jobCatalogLevel?: {
    name?: string | null
    roleName?: string | null
  } | null
  jobCatalogRole?: string | null
  jobCatalogTreeLevel?: {
    jobCatalogTitle?: string | null
  } | null
  _policies?: {
    seeJobTitle?: {
      can?: boolean
    } | null
  } | null
}

interface Permissions {
  canSeeJobTitle: boolean
  canSeeJobCatalog: boolean
  canSeeJobCatalogTree: boolean
  hasLegacyJobCatalog: boolean
}

export const getEmployeeJobPosition = (
  referenceContract: ReferenceContractData | null | undefined,
  permissions: Permissions
): string => {
  const { canSeeJobTitle, canSeeJobCatalog, canSeeJobCatalogTree, hasLegacyJobCatalog } =
    permissions

  if (!canSeeJobTitle) return ''

  const canSeeEmployeeJobTitle = referenceContract?._policies?.seeJobTitle?.can ?? false

  if (!canSeeEmployeeJobTitle) return ''

  const preferredJobTitle = referenceContract?.jobTitle ?? ''

  if (preferredJobTitle) return preferredJobTitle

  if (hasLegacyJobCatalog) {
    if (!canSeeJobCatalog) return ''

    const jobCatalogLevel = referenceContract?.jobCatalogLevel
    const jobRoleName = jobCatalogLevel?.roleName || referenceContract?.jobCatalogRole || ''
    const jobLevelName = jobCatalogLevel?.name || ''

    if (!jobLevelName || jobLevelName === '__default__' || jobLevelName === 'null') {
      return jobRoleName
    }

    return [jobRoleName, jobLevelName].filter(Boolean).join(', ')
  }

  if (!canSeeJobCatalogTree) return ''

  return referenceContract?.jobCatalogTreeLevel?.jobCatalogTitle || ''
}
